export default __webpack_public_path__ + "static/media/4_Osmos_Trame_Cenere_60x120_Matt.2a930473.jpg";